import React from 'react';
import { Box } from '@tanium/react-box';
import { ThemeZIndices } from '@tanium/theme-data';
import { NavBarBaseProps } from './NavBarBaseProps';
import { NavBarOpen } from './open/NavBarOpen';
import { NavBarPinned } from './pinned/NavBarPinned';

/**
 * Renders the appropriate variation of the nav bar depending on state.
 */
export const NavBarBase = ({
  sections,
  state,
  onMouseEnter,
  onMouseLeave,
  onToggleSectionExpanded,
}: NavBarBaseProps) =>
  state !== 'closed' ? (
    <Box
      pt={1}
      mt={-1}
      position={state === 'open' ? 'absolute' : 'relative'}
      zIndex={state === 'open' ? ThemeZIndices.Popover : 'auto'}
      height={state === 'pinned' ? '100%' : undefined}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {state === 'pinned' && (
        <NavBarPinned sections={sections} onToggleSectionExpanded={onToggleSectionExpanded} />
      )}
      {state === 'open' && <NavBarOpen sections={sections} />}
    </Box>
  ) : null;
